import { isNil, isBoolean, isString, isObject, isArray, isEmpty } from 'lodash';

const useFiltersCount = (
  filters: Record<string, unknown>,
  excludedKeys: string[] = [],
): number => {
  const filterValues = Object.entries(filters)
    .filter((entry) => !excludedKeys.includes(entry[0]))
    .map((entry) => entry[1]);
  const appliedFilters = filterValues.filter((filterValue) => {
    if (isBoolean(filterValue) && !filterValue) {
      return false;
    }

    if (isNil(filterValue)) {
      return false;
    }

    if (isString(filterValue) && filterValue.length === 0) {
      return false;
    }

    if (isObject(filterValue) || isArray(filterValue)) {
      if (isEmpty(filterValue)) {
        return false;
      }
    }

    return true;
  });

  return appliedFilters.length;
};

export default useFiltersCount;
